import React, { useState } from "react";
import "./trustedDms.css";

import {
  FiUsers,
  FiShoppingCart,
  FiPackage,
  FiTag,
  FiFileText,
  FiCreditCard,
  FiRotateCcw,
  FiBarChart2,
  FiRepeat,
  FiDollarSign,
} from "react-icons/fi";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import DmsBookingModal from "./dmsBookingModal";

const TrustedDms = () => {
  const [showDmsModal, setShowDmsModal] = useState(false);
  const dmsModules = [
    {
      number: "01",
      icon: <FiUsers />,
      title: "Distributor & Dealer Management",
      description:
        "Streamline distributor onboarding and dealer management while centralizing customer data, hierarchy, territory mapping, credit limits and performance tracking.",
      delay: 100,
    },
    {
      number: "02",
      icon: <FiShoppingCart />,
      title: "Primary & Secondary Sales",
      description:
        "Track product movement across manufacturer, distributor, dealer and retailer channels with sales and territory-level visibility.",
      delay: 180,
    },
    {
      number: "03",
      icon: <FiFileText />,
      title: "Distributor Order Management",
      description:
        "Digitize the complete order lifecycle from booking and approval to processing, dispatch, delivery and invoicing.",
      delay: 260,
    },
    {
      number: "04",
      icon: <FiPackage />,
      title: "Inventory & Stock Management",
      description:
        "Monitor distributor and warehouse stock, batch inventory, expiry, stock ageing, transfers and replenishment requirements.",
      delay: 340,
    },
    {
      number: "05",
      icon: <FiTag />,
      title: "Scheme & Promotion Management",
      description:
        "Configure product, quantity, slab, discount, distributor and retailer schemes while tracking scheme performance.",
      delay: 420,
    },
    {
      number: "06",
      icon: <FiCreditCard />,
      title: "Claims Management",
      description:
        "Manage distributor claims from creation and verification through approvals, settlement, history and reporting.",
      delay: 500,
    },
    {
      number: "07",
      icon: <FiRotateCcw />,
      title: "Billing & Returns",
      description:
        "Support digital invoicing, GST-ready billing, credit and debit notes, returns, payments and customer transaction history.",
      delay: 580,
    },
    {
      number: "08",
      icon: <FiBarChart2 />,
      title: "Real-Time Distribution Dashboard",
      description:
        "Monitor sales, orders, inventory, collections, claims, returns, outstanding management, invoice history, customer ledgers and distributor performance through powerful business dashboards.",
      delay: 660,
    },
    {
      number: "09",
      icon: <FiRepeat />,
      title: "Returns & Stock Movement Control",
      description:
        "Control product movement in both directions across sales, dispatch, delivery, returns, replacement and stock adjustment. Maintain better control over damaged, expired and returned products.",
      delay: 740,
    },
    {
      number: "10",
      icon: <FiDollarSign />,
      title: "Collections & Outstanding Management",
      description:
        "Improve visibility into distributor payments with outstanding invoices, payment due dates, collection status, credit limits, ageing reports, payment history and distributor ledgers.",
      delay: 820,
    },
  ];

  return (
    <>
      <section className="trusted-dms-section">
        <div
          className="trusted-dms-glow trusted-dms-glow-one"
          aria-hidden="true"
        ></div>
        <div
          className="trusted-dms-glow trusted-dms-glow-two"
          aria-hidden="true"
        ></div>
        <div className="trusted-dms-grid" aria-hidden="true"></div>
        <div className="container">
          <div
            className="trusted-dms-heading"
            data-aos="fade-up"
            data-aos-duration="850"
          >
            <div className="trusted-dms-label">CORE DMS MODULES</div>
            <h2>
              One Platform.
              <br />
              <span>Complete Distribution Control.</span>
            </h2>
            <p>
              Connect your distributors, sales teams, inventory, orders,
              schemes, claims and business reporting through one intelligent
              distribution management platform.
            </p>
            <div className="trusted-dms-divider">
              <span className="trusted-dms-divider-small"></span>
              <span className="trusted-dms-divider-large"></span>
            </div>
          </div>
          <div className="row g-4">
            {dmsModules.map((module) => (
              <div className="col-xl-3 col-lg-6 col-md-6" key={module.number}>
                <div
                  className="trusted-dms-module-card"
                  data-aos="fade-up"
                  data-aos-duration="750"
                  data-aos-delay={module.delay}
                >
                  <div className="trusted-dms-card-top">
                    <div className="trusted-dms-icon">{module.icon}</div>

                    <span className="trusted-dms-card-number">
                      {module.number}
                    </span>
                  </div>

                  <h3>{module.title}</h3>

                  <p>{module.description}</p>

                  <div className="trusted-dms-card-line"></div>
                </div>
              </div>
            ))}
          </div>
          <div
            className="trusted-dms-cta"
            data-aos="fade-up"
            data-aos-duration="800"
            data-aos-delay="150"
          >
            <button
              type="button"
              className="trusted-dms-cta-btn"
              onClick={() => setShowDmsModal(true)}
            >
              Explore Techcognics DMS
              <span>
                <ArrowForwardIcon fontSize="small" />
              </span>
            </button>
          </div>

          <div
            className="trusted-dms-bottom"
            data-aos="fade-up"
            data-aos-duration="800"
            data-aos-delay="700"
          >
            <span className="trusted-dms-bottom-line"></span>
            <div className="trusted-dms-bottom-content">
              <strong>Smarter Distribution.</strong>
              <span>Faster Sales. Complete Channel Visibility.</span>
            </div>
            <span className="trusted-dms-bottom-line"></span>
          </div>
        </div>
      </section>
      <DmsBookingModal
        show={showDmsModal}
        onClose={() => setShowDmsModal(false)}
      />
    </>
  );
};

export default TrustedDms;
